<template>
  <div class="divBox">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="container">
          <el-form :inline="true">
            <el-form-item label="订单状态：">
              <el-radio-group v-model="tableFrom.team_status" type="button" @change="getList(1)">
                <el-radio-button label="">全部 {{ '(' +orderChartType.all?orderChartType.all:0 + ')' }}</el-radio-button>
                <el-radio-button
                  label="0"
                >已提交 {{ '(' +orderChartType.sublimtData?orderChartType.sublimtData:0+ ')' }}</el-radio-button>
                <el-radio-button
                  label="1"
                >审核通过 {{ '(' +orderChartType.successData?orderChartType.successData:0+ ')' }}</el-radio-button>
                <el-radio-button
                  label="2"
                >审核拒绝 {{ '(' +orderChartType.failData?orderChartType.failData:0+ ')' }}</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="时间选择：" class="mr10" style="width: 100%">
              <el-radio-group
                v-model="tableFrom.date"
                type="button"
                class="mr20"
                size="small"
                @change="selectChange(tableFrom.date)"
              >
                <el-radio-button
                  v-for="(item,i) in fromList.fromTxt"
                  :key="i"
                  :label="item.val"
                >{{ item.text }}</el-radio-button>
              </el-radio-group>
              <el-date-picker
                v-model="timeVal"
                value-format="yyyy/MM/dd"
                format="yyyy/MM/dd"
                size="small"
                type="daterange"
                placement="bottom-end"
                placeholder="自定义时间"
                style="width: 260px;"
                @change="onchangeTime"
              />
            </el-form-item>
            <el-form-item label="关键字搜索：" class="mr10">
              <el-input
                v-model="tableFrom.keyword"
                @keyup.enter.native="getList(1)"
                placeholder="请输入用户名称手机号"
                class="selWidth"
                size="small"
              >
                <el-button slot="append" icon="el-icon-search" size="small" class="el-button-solt" @click="getList(1)" />
              </el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="tableData.data" style="width: 100%" size="mini" @rowclick.stop="closeEdit" :row-class-name="tableRowClassName">
        <el-table-column prop="team_id" label="ID" min-width="50" />
        <el-table-column prop="user.nickname" label="用户昵称" min-width="100" />
        <el-table-column prop="team_name" label="档口名称" min-width="90" />
        <el-table-column label="执照" min-width="80">
          <template slot-scope="scope">
            <div class="demo-image__preview">
              <el-image
                style="width: 36px; height: 36px"
                :src="scope.row.business_license_img"
                :preview-src-list="[scope.row.business_license_img]"
              />
              <el-image
                style="width: 36px; height: 36px"
                :src="scope.row.legal_person_card_img"
                :preview-src-list="[scope.row.legal_person_card_img]"
              />
              <el-image
                style="width: 36px; height: 36px"
                :src="scope.row.legal_person_card_back_img"
                :preview-src-list="[scope.row.legal_person_card_back_img]"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="lagel_person_name" label="姓名" sortable min-width="100" />
        <el-table-column prop="lagel_person_card" label="身份证号" sortable min-width="100" />
        <el-table-column prop="lagal_person_address" label="地址" sortable min-width="100" />
        <el-table-column prop="lagal_person_mobile" label="手机号" sortable min-width="100" />
        <el-table-column label="状态" min-width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.team_status == 1 ? '审核通过' : (scope.row.team_status == -1 ? '审核拒绝' : '待审核') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if = 'scope.row.team_status == 0' @click="onEdit(scope.row.team_id,scope.row)">编辑状态</el-button>
            <el-button
              v-if="scope.row.team_status == 1"
              type="text"
              size="small"
              @click="onLogo(scope.row.team_id)"
            >登录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          :page-sizes="[20, 40, 60, 80]"
          :page-size="tableFrom.limit"
          :current-page="tableFrom.page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableData.total"
          @size-change="handleSizeChange"
          @current-change="pageChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import {replyListApi, replyCreateApi, replyDeleteApi, productSort, replyShieldApi} from "@/api/product";
import { fromList } from "@/libs/constants.js";
import {appraisalEntityChartListApi} from "@/api/appraisal";
import team from "@/router/modules/team";
import {teamChartListApi, teamListApi, teamLoginApi, teamStatusUpdateApi} from "@/api/team";
import {recoveryOrderUpdateApi} from "@/api/recovery";
import {merchantLoginApi} from "@/api/merchant";
import Cookies from "js-cookie";
import SettingMer from "@/libs/settingMer";
export default {
  name: "TeamList",
  data() {
    return {
      fromList: fromList,
      tableData: {
        data: [],
        total: 0,
      },
      listLoading: true,
      tableFrom: {
        page: 1,
        limit: 20,
        date: "",
        keyword: "",
      },
      timeVal: [],
      props: {},
      tabClickIndex: '',
      orderChartType: {},

    };
  },
  mounted() {
    this.getList(1);
    this.headerList()
  },
  methods: {
    headerList() {
      teamChartListApi()
        .then((res) => {
          this.orderChartType = res.data;
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    // 把每一行的索引放进row
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    // 添加明细原因 row 当前行 column 当前列
    tabClick(row) {
      this.tabClickIndex = row.index;
      //   this.tabClickLabel = column.label;
    },
    // 失去焦点初始化
    inputBlur(scope) {
      if(!scope.row.sort || scope.row.sort<0)scope.row.sort=0
      productSort(scope.row.reply_id,{sort:scope.row.sort})
        .then((res) => {
          this.closeEdit();
          //   this.$message.success(res.message);
        }).catch((res) => {
        //  this.$message.error(res.message);
      });
    },
    closeEdit(){
      this.tabClickIndex = null;
    },
    add() {
      this.$modalForm(replyCreateApi()).then(() => this.getList(1));
    },
    // 选择时间
    selectChange(tab) {
      this.tableFrom.date = tab;
      this.timeVal = [];
      // this.tableFrom.page = 1;
      this.getList(1);
    },
    // 具体日期
    onchangeTime(e) {
      this.timeVal = e;
      // this.tableFrom.date = this.timeVal ? this.timeVal.join("-") : "";
      this.tableFrom.date = e ? this.timeVal.join('-') : ''
      // this.tableFrom.page = 1;
      this.getList(1);
    },
    // 列表
    getList(num) {
      this.listLoading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      teamListApi(this.tableFrom)
        .then((res) => {
          this.tableData.data = res.data.list;
          this.tableData.total = res.data.count;
          this.listLoading = false;
        })
        .catch((res) => {
          this.listLoading = false;
          this.$message.error(res.message);
        });
    },
    pageChange(page) {
      this.tableFrom.page = page;
      this.getList('');
    },
    handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList('');
    },
    onEdit(id) {
      this.$modalForm(teamStatusUpdateApi(id)).then(() => this.getList(''))
    },

    onLogo(id) {
      teamLoginApi(id)
        .then(res => {
          Cookies.set("teamToken", res.data.token);
          window.open(SettingMer.httpUrl + res.data.url);
        })
        .catch(res => {
          this.$message.error(res.message);
        });
    },

  },
};
</script>

<style scoped lang="scss">
.selWidth {
  width: 300px !important;
}
/deep/.el-rate{
  margin-top: 9px;
}
</style>
